import React from 'react';
import { logout } from '../userSlice';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import axios from 'axios';

function Logout() {
    const dispatch = useDispatch();
    const handleLogout = async () => {
        try {
            await axios.post('/api/logout');
        } catch (error) {
            console.error('Logout API failed:', error);
        }
        dispatch(logout());
        localStorage.clear();
    };

    return (
        <Link
            to="/login"
            onClick={handleLogout}
            className="flex-1 font-montserrat small not-italic font-semibold tracking-[0px] leading-[120%] relative no-underline text-dark-gray"
        >
            Déconnexion
        </Link>
    );
}

export default Logout;
